import axios from '@/services/axiosConfig'

const endPoint = {
	lookupCreateTrendList: (instId, scope) =>
		`/institute/${instId}/dashboard/inventory/trend/list/create?scope=${scope}`,
	lookupCreateTrendSummary: (instId, scope) =>
		`/institute/${instId}/dashboard/inventory/trend/summary/create?scope=${scope}`,
	lookupDisposalTrendList: (instId, scope) =>
		`/institute/${instId}/dashboard/inventory/trend/list/dispose?scope=${scope}`,
	lookupDisposalTrendSummary: (instId, scope) =>
		`/institute/${instId}/dashboard/inventory/trend/summary/dispose?scope=${scope}`,
	lookupUseTrendList: (instId, scope) =>
		`/institute/${instId}/dashboard/inventory/trend/list/use?scope=${scope}`,
	lookupUseTrendSummary: (instId, scope) =>
		`/institute/${instId}/dashboard/inventory/trend/summary/use`,
	lookupPossessionTrendList: instId =>
		`/institute/${instId}/dashboard/inventory/trend/supply`,
	lookupDisposalItem: instId =>
		`/institute/${instId}/dashboard/inventory/trend/need/dispose`,
	lookupMsdsUpload: instId =>
		`/institute/${instId}/dashboard/safety/msds/trend`,
	lookupDashboardList: instId =>
		`/institute/${instId}/dashboard/component/setting/mobile`,
	lookupDiagnosisList: instId =>
		`institute/${instId}/dashboard/safety/specialdiagnosis`,
	lookupDangerStorage: instId =>
		`institute/${instId}/dashboard/safety/dangerstorage`,
	lookupLegalList: instId => `institute/${instId}/dashboard/safety/legal`,
}

const dashboardAPI = {
	lookupCreateTrendList: (instId, scope) =>
		axios.get(endPoint.lookupCreateTrendList(instId, scope)),
	lookupCreateTrendSummary: (instId, scope) =>
		axios.get(endPoint.lookupCreateTrendSummary(instId, scope)),
	lookupDisposalTrendList: (instId, scope) =>
		axios.get(endPoint.lookupDisposalTrendList(instId, scope)),
	lookupDisposalTrendSummary: (instId, scope) =>
		axios.get(endPoint.lookupDisposalTrendSummary(instId, scope)),
	lookupUseTrendList: (instId, scope) =>
		axios.get(endPoint.lookupUseTrendList(instId, scope)),
	lookupUseTrendSummary: (instId, scope) =>
		axios.get(endPoint.lookupUseTrendSummary(instId, scope)),
	lookupPossessionTrendList: instId =>
		axios.get(endPoint.lookupPossessionTrendList(instId)),
	lookupDisposalItem: instId =>
		axios.get(endPoint.lookupDisposalItem(instId)),
	lookupMsdsUpload: instId => axios.get(endPoint.lookupMsdsUpload(instId)),
	lookupDashboardList: instId =>
		axios.get(endPoint.lookupDashboardList(instId)),
	lookupDiagnosisList: instId =>
		axios.get(endPoint.lookupDiagnosisList(instId)),
	lookupDangerStorage: instId =>
		axios.get(endPoint.lookupDangerStorage(instId)),
	lookupLegalList: instId => axios.get(endPoint.lookupLegalList(instId)),
	updateDashboardSetting: (instId, body) =>
		axios.put(endPoint.lookupDashboardList(instId), body),
}

export default dashboardAPI
